import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { GlobalErrorHandler } from './core/error/error-handler.service';
import { environment } from 'src/environments/environment';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { idSystemTokenInterceptor, provideIdSystem } from './core/service/id-system';

//registerLocaleData(localeEn, 'en')
//registerLocaleData(localeRu, 'ru')

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      /* Откатил кейклок
      withInterceptors([authErrorInterceptor, includeBearerTokenInterceptor]),
      */
      withInterceptors([idSystemTokenInterceptor]),
    ),
    ...provideIdSystem({
      ...environment.idSystem,
      tokenInterceptor: {
        urlPattern: environment.api.url
      }
    }),
    /* Откатил кейклок
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },

      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
      },
      features: [
        withAutoRefreshToken({
          sessionTimeout: 300_000,
          onInactivityTimeout: 'none'
        })
      ],
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [{
        urlPattern: new RegExp('^' + escapeStringRegexp(environment.api.url)),
        httpMethods: ['GET', 'POST'] // Token added only for GET and POST
      }]
    },*/
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    // Настройка переводов
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),
  ]
}
